import RootRequest from "./RootRequest";

export default class CargoTypeRequest extends RootRequest {
  get apiResource() {
    return "api/cargo-type";
  }
}

export const cargoTypeRequest = new CargoTypeRequest();
